import { useMutation, useQueryClient } from '@tanstack/react-query'

import { api } from '../../../services/api'
import { queriesKeys } from '../queriesKeys'

export const useRequestDriverLetter = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: api.earnings.requestDriverLetter,
    mutationKey: ['request-driver-letter'],
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queriesKeys.earnings.getEarningsLetter(),
      })
    },
  })
}
